export const EDIT_PROFILE_URL = "/edit-profile-details";
